import React from 'react'
import { Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import { Layout } from '@surecompanies/core_components'
import Page from 'layouts/Page'
import PageWrapper from 'enrollment-platform/PageWrapper'
import BreadcrumbNav from 'enrollment-platform/components/Breadcrumbs'
import { FINANCE_PATH } from '../../constants'
import { BulkInvoiceUpload as BulkInvoiceUploadContent } from '../../components/InvoiceManagement/BulkInvoiceUpload'
import RequirePermission from 'enrollment-platform/rbac/RequirePermission'
import { NoAdminAccess } from 'enrollment-platform/rbac/NoAdminAccess'
import { RbacActions, RbacSubjects } from 'enrollment-platform/rbac/constants'

const { Content } = Layout

const howToTooltip = (
  <Tooltip
    title={
      <div style={{ padding: '4px 2px' }}>
        <div style={{ fontWeight: 600, marginBottom: 8, fontSize: 13 }}>
          How to use bulk upload
        </div>
        <ol
          style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8, fontSize: 13 }}
        >
          <li>Select the billing period and upload .xlsx invoice files</li>
          <li>The system matches each file to a client by company name</li>
          <li>
            Review the deliveries and click Send on the ones ready to send
          </li>
          <li>Sent invoices will be emailed once the email job is connected</li>
        </ol>
      </div>
    }
    overlayInnerStyle={{ padding: '12px 16px' }}
    overlayStyle={{ maxWidth: 360 }}
  >
    <InfoCircleOutlined
      style={{
        fontSize: 14,
        color: '#9ca3af',
        marginLeft: 8,
        cursor: 'help',
        verticalAlign: 'middle',
      }}
    />
  </Tooltip>
)

const BulkInvoiceUpload: React.FC = () => {
  return (
    <PageWrapper>
      <Page
        title={<>Invoice Management{howToTooltip}</>}
        /*
          Wider than Page's 1280px default: the delivery table carries ten
          columns and needs ~1390px before it starts scrolling sideways. The
          width is still clamped to 100%, so narrower screens are unaffected.
        */
        maxWidth="1600px"
        breadcrumb={
          <BreadcrumbNav
            items={[
              { title: 'Finance', path: FINANCE_PATH },
              { title: 'Invoice Management' },
            ]}
          />
        }
      >
        <Layout style={{ backgroundColor: '#f6f9fc' }}>
          <Content
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
            }}
          >
            <RequirePermission
              action={RbacActions.Manage}
              subject={RbacSubjects.InvoiceManagement}
              fallback={<NoAdminAccess />}
            >
              <BulkInvoiceUploadContent />
            </RequirePermission>
          </Content>
        </Layout>
      </Page>
    </PageWrapper>
  )
}

export default BulkInvoiceUpload
